import request from '@/utils/request'

export async function login(data) {
  return request({
    url: '/hhxc-auth/oauth/token',
    method: 'post',
    params: { ...data, grant_type: 'password' },
  })
}

export async function socialLogin(data) {
  return request({
    url: '/socialLogin',
    method: 'post',
    data,
  })
}

export async function feishuLogin(params) {
  return request({
    url: '/hhxc-auth/oauth/feishu/login',
    method: 'get',
    params,
  })
}

export function getUserInfo() {
  //此处为了兼容mock.js使用data传递accessToken，如果使用mock可以走headers
  return request({
    url: `/hhxc-admin/api/v1/user/getUerInfo`,
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function register() {
  return request({
    url: '/register',
    method: 'post',
  })
}

// 用户列表分页
export function apiGetUserList(data) {
  return request({
    url: `/hhxc-admin/api/v1/user/userPage`,
    method: 'post',
    data,
  })
}

// 所有用户列表
export function apiAllUserList(params) {
  return request({
    url: `/hhxc-admin/api/v1/user/select`,
    method: 'get',
    params,
  })
}

// 获取菜单路由
export function getRouterList(params) {
  return request({
    url: '/hhxc-admin/api/v1/menu/route',
    method: 'get',
    params,
  })
}

// 新增用户
export function apiAddNewRole(data) {
  return request({
    url: `/hhxc-admin/api/v1/user`,
    method: 'post',
    data,
  })
}
// 编辑用户
export function apiModifyRole(data) {
  return request({
    url: `/hhxc-admin/api/v1/user/${data.id}`,
    method: 'put',
    data,
  })
}
// 用户详情
export function apidDetailsRole(id) {
  return request({
    url: `/hhxc-admin/api/v1/user/${id}`,
    method: 'get',
  })
}

// 删除用户
export function apiDeleteRole(data) {
  return request({
    url: `/hhxc-admin/api/v1/user/${data.id}`,
    method: 'delete',
  })
}

// 选择性更新用户（停用，启用，重置密码）
export function apiSelectUpdataUser(data) {
  return request({
    url: `/hhxc-admin/api/v1/user/${data.id}`,
    method: 'PATCH',
    data,
  })
}

// 获取所有用户列表
export function apiGetAllUser(params) {
  return request({
    url: `/hhxc-admin/api/v1/user/select`,
    method: 'GET',
    params,
  })
}

//修改密码
export function apiMoidfyPassword(data) {
  return request({
    url: `/hhxc-admin/api/v1/user/${data.id}`,
    method: 'PATCH',
    data,
  })
}

// 项目组查询用户
export function apiFindProjectGroupUserList(params) {
  return request({
    url: `/hhxc-admin/api/v1/user/selectByProjectGroupId/${params.projectGroupId}`,
    method: 'GET',
  })
}
